export default __webpack_public_path__ + "static/media/cphgamelab_Logo.cd060920.svg";